const StatusActive = Object.freeze({
  InActive: 0,
  Active: 1
});

export default StatusActive;
